import { UpdateUISettingSuccess } from 'packages/user-prefs/src/lib/store/actions';
import { createReducer, on } from '@ngrx/store';
import { Currency } from '@aston/foundation';

import { getStateFromPreviousSession } from '../root-state';
import { withEntityReducer } from '../functions';

import { initialState, IAppState } from './state';
import * as featureActions from './actions';


export const appReducer = createReducer<IAppState>(
	initialState,

	...withEntityReducer<IAppState>('tenant', featureActions.tenantActions),
	...withEntityReducer<IAppState>('factorConfig', featureActions.factorConfigActions),

	on(featureActions.StartInitializer, _ => ({
		...initialState,
		isLoading: true,
		errorMessage: null,
		bootstrapError: null,
	})),

	on(featureActions.FinishInitializer, state => ({
		...state,
		isFinished: true,
		bootstrapError: null,
	})),

	on(featureActions.AppReady, state => ({
		...state,
		isLoading: false,
		bootstrapError: null,
	})),

	on(featureActions.CriticalFailure, (state, action) => ({
		...state,
		bootstrapError: action.bootstrapError,
	})),

	on(featureActions.UpdateAppConfigurationSuccess, (state, action) => ({
		...state,
		config: action.config
	})),

	on(featureActions.LoadTenantIdentitySuccess, (state, action) => {
		const config = state.config;
		config.currency = action.entity.currencyCode as Currency;
		return {
			...state,
			config
		};
	}),

	on(featureActions.LoadValidatorsRequest, state => ({
		...state,
		validatorsLoaded: false
	})),

	on(featureActions.LoadValidatorsSuccess, state => ({
		...state,
		validatorsLoaded: true
	})),

	on(featureActions.Login, (state, action) => ({
		...state,
		user: action.userData
	})),

	on(featureActions.ImpersonateSupport, (state) => ({
		...state,
		user: {
			...state.user,
			isSupport: !state.user.isSupport
		}
	})),

	on(featureActions.Logout, state => ({
		...state,
		user: null,
		scripts: {}
	})),

	on(featureActions.UpdateUserSessionSuccess, (state, action) => ({
		...state,
		userSession: {
			...state.userSession,
			...action.userSession
		}
	})),

	on(featureActions.UserDataSuccess, (state, action) => ({
		...state,
		user: action.userData
	})),

	on(featureActions.LoadScriptRequest, (state, action) => {
		if (state.scripts[action.script]) {
			return state;
		} else {
			return {
				...state,
				scripts: {
					...state.scripts,
					[action.script]: false
				}
			};
		}
	}),

	on(featureActions.LoadScriptSuccess, (state, action) => ({
		...state,
		scripts: {
			...state.scripts,
			[action.script]: true
		}
	})),

	on(UpdateUISettingSuccess, (state, action) => ({
		...state,
		user: {
			...state.user,
			userPrefs: {
				...state.user.userPrefs,
				...action.entity
			}
		}
	})),
);

export function logoutMetaReducer(reducer) {
	return function (state, action) {
		return reducer(action.type === featureActions.Logout.type ? getStateFromPreviousSession(state) : state, action);
	};
}
